import browserUpdate from 'browser-update';

$(function() {
    browserUpdate({
        required: {
            i: 11,
        },
        reminder: 0,
        reminderClosed: 0,
        noclose: true,
        no_permanent_hide: true,
        text_in_nl: {
            msg: 'Jouw webbrowser ({brow_name}) is verouderd.',
            msgmore: 'Update jouw browser voor meer veiligheid, snelheid en om deze site te kunnen gebruiken.',
            bupdate: 'Klik hier om jouw browser te updaten',
        },
    });
});
